import React from 'react';
import PropTypes from 'prop-types';

const Buttons = props => (
  <section className="module-filter top">
    <div>
      <button
        id="button-associate"
        className="normal_button margin-right desactive"
        onClick={props.handleHomologation}
      >
        {props.language.account.createDriver.associateDrivers}
      </button>
      <button
        id="button-create"
        className="normal_button desactive"
        data-close="ok"
        onClick={props.handleModalCreate}
      >
        {props.language.account.createDriver.createOne}
      </button>
    </div>
    <div>
      <button
        data-close="ok"
        onClick={props.handleModalDownload}
        className="normal_button margin-right"
      >
        <i className="fas fa-file-excel" />{' '}
        {props.language.account.homologationDriver.downloadExcel}
      </button>
      <button data-close="ok" onClick={props.handleModalUpdate} className="normal_button">
        {props.language.account.homologationDriver.importExcelFile}
      </button>
    </div>
  </section>
);

export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/homologation_driver/buttons.jsx